var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVrbo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.595,
    height: 83.127,
    viewBox: "0 0 242.595 83.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 126.905,
    height: 40.61,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(-276.524 -1057.818)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 242.595,
    height: 83.127,
    rx: 8,
    transform: "translate(276.524 1057.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vrbo-grid-logo",
    transform: "translate(334.205 1074.935)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M189.577,59.619v.061c7.848.66,10.152,6.234,10.041,9.472-.183,9.381-7.452,16.934-19.178,17.858v.051c12.884-.772,20.427-7.432,20.589-16.975C201.008,66.574,198.451,60.137,189.577,59.619Z",
    transform: "translate(-77.901 -46.492)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M180.44,86.971A19.209,19.209,0,0,0,198.359,68.25c0-2.965-2.03-7.838-8.853-8.386v.051c5.645.6,7.635,4.711,7.594,7.4-.162,9.046-7.177,18.63-16.6,19.594Z",
    transform: "translate(-77.901 -46.564)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M180.555,86.866C188.891,86,195.6,75.282,195.784,66.4c0-2.406-1.533-5.767-6.294-6.3v.061c3.747.569,5.076,3.178,5.076,5.32-.152,8.7-6.69,20.376-13.868,21.32Z",
    transform: "translate(-77.935 -46.632)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M178.53,86.671v.071c6.091-.883,12.375-13.685,12.528-22.213a4.06,4.06,0,0,0-3.787-4.213v.061a2.975,2.975,0,0,1,2.467,3.228C189.5,71.94,183.413,85.767,178.53,86.671Zm-3.828-3.31c.142-8.02,6.467-22.112,11.168-23.066v-.071c-5.888.873-12.4,13.9-12.549,22.163a3.991,3.991,0,0,0,3.8,4.284V86.61a2.842,2.842,0,0,1-2.416-3.249Z",
    transform: "translate(-75.798 -46.671)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M171.052,81.389c.152-8.477,6.964-20.376,13.888-21.32v-.061c-8.122.863-15.056,11.746-15.229,20.406a6.4,6.4,0,0,0,6.294,6.376v-.061A5.249,5.249,0,0,1,171.052,81.389Z",
    transform: "translate(-74.736 -46.607)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M167.38,79.4c.152-8.883,7.391-18.63,16.558-19.594v-.061a19.554,19.554,0,0,0-17.9,18.67c0,2.965,2.03,8,8.863,8.447V86.8C169.015,86.277,167.339,82.064,167.38,79.4Z",
    transform: "translate(-73.653 -46.53)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M153.586,77.427c.162-9.33,8.2-16.965,19.228-17.848v-.061c-12.345.761-20.426,7.421-20.589,16.924-.071,3.513,2.5,10.01,11.361,10.518C155.85,86.351,153.536,80.666,153.586,77.427Zm-6.274-17.706c-4.254-.579-9.391,1.919-12.284,6.3l.051.071c2.741-3.939,7.37-6.284,11.168-5.756,2.558.345,4.315,2.284,3.959,6.091-.9,9.7-9.077,20.589-22.153,20.559v.071a22.975,22.975,0,0,0,23.736-20.6C152.144,62.26,150.2,60.117,147.312,59.721Z",
    transform: "translate(-62.448 -46.462)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M148.689,66.985c.315-3.34-1.177-5.076-3.523-5.391-3.381-.457-7.492,1.6-9.98,5.228l.051.061c2.284-3.127,5.939-5.076,8.873-4.67,2.03.274,3.371,1.8,3.046,4.741-.782,8.345-8.742,19.817-19.046,20.457C139.623,87.4,147.837,76.082,148.689,66.985Z",
    transform: "translate(-62.465 -47.056)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M128.312,87.743V87.8c9.594-1.147,16.7-12.8,17.462-20.356.223-2.477-.914-3.8-2.609-4.061-2.559-.355-5.746,1.371-7.716,4.132v.061c1.878-2.426,4.5-3.868,6.569-3.584,1.462.2,2.355,1.31,2.162,3.33C143.541,74.21,137.013,85.925,128.312,87.743Z",
    transform: "translate(-62.525 -47.59)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M127.332,80.919v.091c7.107-1.909,13.7-14.213,14.213-20.3.142-1.553-.548-2.467-1.685-2.619-1.7-.234-3.848,1.015-5.422,3.046v.061c1.31-1.563,3.046-2.67,4.315-2.5.823.112,1.361.833,1.249,1.98C139.606,66,133.515,78.28,127.332,80.919Zm-1.117-6.914a21.24,21.24,0,0,0-1.6,5.2,1.94,1.94,0,0,0,1.015,1.645,1.906,1.906,0,0,0,.3.122v-.091a1.207,1.207,0,0,1-.345-1.1,25.861,25.861,0,0,1,1.838-5.279l13.2-33.5-1.858.365c.1.426-3.462,9.188-3.6,9.624Z",
    transform: "translate(-61.433 -41)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M122.837,73.266a22.693,22.693,0,0,0-1.442,5.005c-.162,1.838,1.442,2.833,3.594,3.157v-.061c-1.472-.264-2.609-1.015-2.477-2.437a25.741,25.741,0,0,1,1.543-5.076l8.792-22.62c.214-.6,3.553-8.68,3.046-9.2l-1.807.365v.1c.071,1.97-2.213,7.36-2.681,8.63Z",
    transform: "translate(-60.481 -41.306)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M127.652,51.327l-8.285,21.208a19.417,19.417,0,0,0-1.4,4.68c-.223,2.589,1.9,4.376,5.868,4.65a10.352,10.352,0,0,1-2.4-.558,3.046,3.046,0,0,1-2.3-3.33,20.372,20.372,0,0,1,1.482-4.893l8.447-21.706c.427-1.147,2.843-6.63,2.264-8.3l-1.746.345v.1C130.535,44.83,128.21,49.906,127.652,51.327Z",
    transform: "translate(-59.468 -41.612)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M123.7,52.078l-7.655,19.736a16.308,16.308,0,0,0-1.279,4.406c-.274,3.239,2.538,5.888,8.122,6.091-4.68-.264-7.229-2.477-6.975-5.4a17.072,17.072,0,0,1,1.34-4.528l7.909-20.3c.711-1.858,2.812-6.416,1.675-7.939l-1.8.365v.1C126.261,46.281,124.515,50.048,123.7,52.078Z",
    transform: "translate(-58.524 -41.926)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M110.8,82.727c-6.305-.274-9.483-3.35-9.137-6.924a15.225,15.225,0,0,1,1.157-4.142l7.3-18.863c.914-2.355,2.619-5.909,1.279-7.665l-1.655.345v.1c1.411,1.584.1,4.183-.863,6.812l-7.269,18.68a13.48,13.48,0,0,0-1.127,4.061c-.345,3.888,3.117,7.411,10.295,7.624ZM102.5,58.95c-.133-2.508-1.615-3.655-3.412-3.655-3.269,0-6.091,2.579-7.868,6.091V60.148c-.142-2.731-2.03-4.853-5.391-4.853-7.107,0-10.609,4.68-11.777,9.98h.061c1.239-4.965,4.548-9.442,10.934-9.442a4.467,4.467,0,0,1,4.863,4.376c.173,3.218-.893,5.726-2.03,8.619L82.7,82.362h1.381L89.261,68.94c.345-.924.67-1.787.964-2.619,1.015-2.132,2.284-4.315,2.944-4.315.487,0,.639.416.67.792a11.454,11.454,0,0,1-1.533,5.756l.061.061a10.7,10.7,0,0,0,2.671-6.4c0-.7-.345-1.2-1.015-1.2-1.107,0-2.518,2.274-3.554,4.68.122-.386.223-.772.325-1.147C91.9,62.148,93.433,60.1,94.855,60.1c.874,0,1.4.6,1.452,1.584.121,2.4-2.03,5.888-3.838,7.036l.061.061c2.457-1.1,5.157-4.7,5-7.645-.071-1.31-.761-2.03-1.858-2.03-1.807,0-3.554,2.1-4.762,4.7a4.689,4.689,0,0,1,.112-.619c1.35-2.792,3.33-5.005,5.533-5.005,1.2,0,2.112.812,2.193,2.4.193,3.492-3.106,7.208-6.091,8.295l.061.061c3.665-.934,7.493-4.863,7.279-8.9-.1-1.909-1.188-2.833-2.6-2.833-2.538.01-4.8,2.284-6.213,5.33v-.5C92.8,58.757,95.352,56.28,98.3,56.28c1.583,0,2.893,1.015,3.046,3.228.244,4.64-4.061,8.569-8.447,9.553l.061.051C98.033,68.341,102.774,64.138,102.5,58.95Z",
    transform: "translate(-46.519 -42.219)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M88.71,64.991a4.061,4.061,0,0,0-4.355-3.98c-5.665,0-8.924,4.213-10.071,8.944h.071c1.259-4.406,4.142-8.4,9.208-8.4A3.513,3.513,0,0,1,87.4,65.052c.142,2.67-1.117,5.614-2.122,8.295l-5.34,13.7h1.421l5.228-13.584C87.7,70.666,88.862,67.885,88.71,64.991Z",
    transform: "translate(-46.587 -46.9)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M86.275,65.539a3.046,3.046,0,0,0-3.33-3.046c-4.447,0-7.168,3.838-8.345,7.909h.061c1.249-3.787,3.807-7.36,7.5-7.36a2.6,2.6,0,0,1,2.782,2.569c.112,2.122-1.35,5.564-2.315,7.97l-5.492,13.9H78.61L84,73.671C84.956,71.164,86.377,68,86.275,65.539Z",
    transform: "translate(-46.681 -47.336)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M83.563,66.159a2.112,2.112,0,0,0-2.294-2.122c-3.046,0-5.472,3.31-6.63,6.812h.071c1.208-3.127,3.279-6.274,5.767-6.274a1.594,1.594,0,0,1,1.777,1.645c.091,1.685-1.614,5.513-2.426,7.635L74.182,87.935h1.411l5.543-13.97C82.091,71.732,83.665,68.1,83.563,66.159Z",
    transform: "translate(-46.558 -47.793)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M75.741,61.932a1.168,1.168,0,0,0-1.259-1.269c-1.8,0-3.736,2.833-4.9,5.777h.071c1.178-2.619,2.995-5.239,4.061-5.239.437,0,.721.223.751.772.061,1.147-1.848,5.452-2.619,7.31L66.1,83.5h1.421l5.7-14.132C74.015,67.394,75.812,63.3,75.741,61.932ZM60.218,73.983l.914-1.919-3.1-15.8c-.863-4.447.173-6.386,3.665-7.056V49.15H58.472c-.934.467-2.914,1.868-1.807,7.107Z",
    transform: "translate(-41.294 -43.404)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M52.1,77.8l.9-1.909L48.939,56.166c-.761-3.827-.437-5.817.833-6.954V49.15H47.579c-.67,1.431-.873,2.863-.1,6.65Zm-1.868,3.807.9-1.888-5.076-23.97c-.893-3.726-.69-5.432-.325-6.6H43.792a21.788,21.788,0,0,0,.772,5.97ZM42.015,49.15H39.731v.061c1.015,1.239,1.32,2.751,2.132,6.091l6.091,28.254h1.371L43.234,55.211A51.863,51.863,0,0,1,42.015,49.15Zm-4.569,0H35v.061c2.234.883,3.33,2.579,4.213,6.548l6.02,27.787H46.6l-6.061-27.96C39.5,50.734,38.4,49.841,37.447,49.15Zm31.127,0c-2.883,1.685-4.6,4.8-8.193,12.528l.091.051c4.152-7.777,6.518-10.873,11.878-12.487V49.15Zm-8.4,12.376.091.061c3.411-8.031,4.3-10.274,5.7-12.376V49.15H63.2v.081C63.488,52.45,62.411,55.414,60.178,61.526Z",
    transform: "translate(-35 -43.404)",
    fill: "#245abc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M69.765,61.4l.091.061c2.162-7.2,2.863-10.376.954-12.315H68.12v.061C71.166,50.287,71.8,53.364,69.765,61.4Zm98.864-3.015V59.76h-.2V58.389h-.589V58.2h1.4v.193Zm2.335,1.371V58.43l-.487,1.31h-.233l-.436-1.31v1.33h-.193l.061-1.563h.355l.406,1.31.467-1.31h.325l.061,1.563Z",
    transform: "translate(-44.77 -43.404)",
    fill: "#245abc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrbo);
export default __webpack_public_path__ + "static/media/vrbo.6723bdd12e82a96ca39148f1f0702e31.svg";
export { ForwardRef as ReactComponent };